import Autocomplete from '@zenbusiness/zui/Autocomplete';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const Container = superstyled({
  name: 'MultipleChoiceSelection',
  slot: 'Container',
  tag: Stack,
  styles: ({ theme }) => ({ gap: theme.spacing(1) })
});

export const CtaContainer = superstyled({
  name: 'CtaContainer',
  tag: Container,
  styles: () => ({ zIndex: 1 })
});

export const Actions = superstyled({
  name: 'CtaContainer',
  slot: 'Actions',
  tag: Stack,
  styles: ({ theme }) => ({
    gap: theme.spacing(1),
    paddingBlock: theme.spacing(1),

    [theme.breakpoints.up('sm')]: { marginBlockStart: theme.spacing(2), paddingBlock: 0 }
  })
});

export const MultipleChoice = superstyled({
  name: 'MultipleChoiceSelection',
  tag: Autocomplete,
  styles: ({ theme }) => ({
    '& .MuiAutocomplete-tag': {
      margin: '2px'
    },
    '& .MuiAutocomplete-tag:nth-of-type(n+11)': {
      backgroundColor: theme.palette.background.red.light,
      '& .MuiChip-label': { color: theme.palette.error.dark }
    },
    minHeight: '60px',
    '& > div': {
      minHeight: '60px',
      '& > div': { minHeight: '60px' },
      '& > label': { padding: '14px 0' }
    }
  })
});
